import { useEffect, useState } from 'react';
import { SarlaftListActions } from './actions';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { asyncGetSarlafts } from '../../../../../services/sarlaft.service';
import { ISelect } from '../../../../../shared/types/shared';
import {
    Sarlaft,
    SarlaftFilter,
} from '../../../../../shared/types/modules/sarlaft';
import { TableTooltip } from '../../../../components/general/table';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import {
    isOnlyViewProfile,
    isSupervisor,
} from '../../../../../shared/types/profiles';

export const useSarlaftList = (filters?: SarlaftFilter) => {
    const navigate = useNavigate();
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<Sarlaft[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [finalFilters, setFinalFilters] = useState<SarlaftFilter>({});
    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<Sarlaft>[] = [];

    if (!isSupervisor(type) && !isOnlyViewProfile(type)) {
        columns.push({
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <SarlaftListActions id={row.id} />,
        });
    }

    columns.push(
        {
            field: 'caseId',
            headerName: 'ID Caso',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip value={row.row.callInfo?.callId || ''} />
            ),
        },
        {
            field: 'consecutiveFormat',
            headerName: 'SARLAFT ID',
            minWidth: 120,
            flex: 0.4,
        },
        {
            field: 'numberForm',
            headerName: 'Número Formulario',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip value={row.row.form?.numberForm || ''} />
            ),
        },
        {
            field: 'state',
            headerName: 'Estado validación',
            minWidth: 150,
            flex: 0.6,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        (row.row.security?.statusValidation as ISelect)?.name ||
                        ''
                    }
                />
            ),
        },
        {
            field: 'document',
            headerName: 'Documento Cuenta',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip value={row.row.account?.document || ''} />
            ),
        },
        {
            field: 'name',
            headerName: 'Nombre de Cuenta',
            minWidth: 150,
            flex: 0.6,
            renderCell: (row) => (
                <TableTooltip value={row.row.account?.name || ''} />
            ),
        },
        {
            field: 'typification',
            headerName: 'Tipificación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        (row.row.typification?.typification1 as ISelect)
                            ?.name || ''
                    }
                />
            ),
        }
    );

    useEffect(() => {
        setPage(0);
        setFinalFilters(filters || {});
    }, [filters]);

    useEffect(() => {
        setLoading(true);
        asyncGetSarlafts(finalFilters, page, pageSize)
            .then((res) => {
                setRows(res.items);
                setTotal(res.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, finalFilters]);

    return {
        navigate,
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
